import React, { FunctionComponent } from 'react';
import { Text } from 'rebass/styled-components';
import { isObject } from 'lodash';
import { Tooltip } from '../..';
import ElidableText from '../../elidable-text';
import { markupValueParser } from '../util/parsers';

export interface MarkupVariableProps {
  variable: string;
  value: string | any;
  isEmphasizedPolicyResult: boolean;
}

// max dimensions per design per design
const MAX_TOOLTIP_WIDTH = 265;
const MAX_TOOLTIP_LINES = 5;

const MarkupVariable: FunctionComponent<MarkupVariableProps> = ({
  variable,
  value,
  isEmphasizedPolicyResult,
}: MarkupVariableProps) => {
  const parent = (
    <Text
      variant={isEmphasizedPolicyResult ? 'hoverableBold' : 'hoverable'}
      sx={{ display: 'inline', whiteSpace: 'pre' }}
    >
      {variable}
    </Text>
  );

  const isObjectDisplay = isObject(value) && !Array.isArray(value);

  const parsedText = markupValueParser(value);

  return (
    <Tooltip
      position="top"
      arrow="center"
      parent={parent}
    >
      {isObjectDisplay ? (
        <Text variant="info">All object values are listed in drawer</Text>
      ) : (
        <ElidableText
          text={parsedText}
          maxWidth={MAX_TOOLTIP_WIDTH}
          lineCount={MAX_TOOLTIP_LINES}
        />
      )}
    </Tooltip>
  );
};

export default MarkupVariable;
